import axios from '../services/dataSources/default';
import asSofologist from '../services/dataSources/asSofologist';
// constants
import * as ACTIONS from './constants';
import { history } from '../store';
// config
import { config } from '../config';

// services
import { deleteUserCookies, deleteSofologistCookies, setSofologistCookie, getSofologistCookie } from '../services/cookieService';
import { getPointOfSales } from '../services/storeService';
import { getCashPaymentConfigDetails } from '../services/configService';


// AUTH
function sofologistLoginSuccess(token, location, isTelStore, dispatch) {
  setSofologistCookie(token, location, isTelStore);
  dispatch({ type: ACTIONS.SOFOLOGIST_LOG_IN, payload: { token, location, isTelStore } });
}

export const loginSofologistFromJWT = cookie => dispatch =>
  dispatch({ type: ACTIONS.SOFOLOGIST_LOG_IN, payload: cookie });

const sofologistLoginFailure = (res, dispatch) => {
  dispatch({
    type: ACTIONS.SOFOLOGIST_LOG_IN_ERRORS,
    payload: { message: 'Oops.. Something went wrong with your log in, please contact IT if the problem persists.' }
  });
  return Promise.reject();
};

export const sofologistLoginSuccessful = (res, location, isTelStore) => (dispatch) => {
  const url = `${config.URLS.MY_SOFOLOGY_API}GoogleAuth`;
  return axios.post(url, null, {
    headers: { Authorization: `Bearer ${res.access_token}` }
  })
    .then((resp) => {
      const sofologistCookie = getSofologistCookie();
      if(sofologistCookie && sofologistCookie.fromLegacyImpersonation) {
        sofologistLoginSuccess(resp.data, location, isTelStore, dispatch);
        history.push('/');
      }
      sofologistLoginSuccess(resp.data, location, isTelStore, dispatch);
    })
    .catch((error) => { sofologistLoginFailure(error, dispatch); });
};

export const sofologistLoginFailed = resp => dispatch =>
  sofologistLoginFailure(resp, dispatch);


export const sofologistLogout = () => (dispatch) => {
  deleteSofologistCookies();
  dispatch({ type: ACTIONS.SOFOLOGIST_LOG_OUT });
  deleteUserCookies();
  dispatch({ type: ACTIONS.USER_LOG_OUT });
};

//
// IMPERSONATION
// old
export const OLD_getCustomerForImpersonation = body => () => {
  const url = `${config.URLS.MY_SOFOLOGY_API}impersonation`;
  return asSofologist.post(url, body);
};

export const getCustomerForImpersonation = (searchTerm, method) => () => {
  const url = `${config.URLS.MY_SOFOLOGY_API}impersonation/findUsers/${method}`;
  return asSofologist.post(url, { searchTerm });
};

export const getCashPaymentConfig = () => dispatch =>
  getCashPaymentConfigDetails()
    .then(cashPaymentConfig => dispatch({
      type: ACTIONS.CASH_PAYMENT_CONFIG_LOADED,
      payload: !!(cashPaymentConfig && cashPaymentConfig.cashPaymentEnabled)
    }));

export const getAllStores = () => dispatch =>
  getPointOfSales()
    .then(stores => dispatch({
      type: ACTIONS.UPDATE_ALL_STORES,
      payload: stores
    }))
    .catch(dispatch({
      type: ACTIONS.SOFOLOGIST_LOG_IN_ERRORS,
      payload: { message: 'MySofology failed to get the list of stores, please contact IT if the problem persists.' }
    }));



// WEBPACK FOOTER //
// ./src/actions/sofologist.js